import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section id="bonuses" className="w-full scroll-mt-6 bg-ivory py-14 sm:py-16" aria-labelledby="bonuses-heading" data-id="element-15" data-mp="gx6o4606sc9x">
      <div className="mx-auto max-w-6xl px-6" data-id="element-16" data-mp="vqtb4um8rlxs">
        <SectionHeading eyebrow="The 7-piece teacher toolkit" eyebrowTone="gold" title={<span id="bonuses-heading" data-id="element-18" data-mp="14tayxdhjommw">7 practical teacher bonuses</span>} lead="120 classes solve what to teach. These seven bonuses cover when to use each class, how to cue it, how to modify it — and what to do when you have no time." data-id="element-17" data-mp="qtjpzr5vxwfr" />

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-19" data-mp="1eicgv97nhe3i">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col rounded-3xl border border-line bg-shell p-4 shadow-soft" data-id="element-20" data-mp="19lc9muz2e5at">
              <div className="rounded-2xl bg-sand p-3" data-id="element-21" data-mp="1nkbx3zauce5e">
                <img src={bonus.image} alt={bonus.alt} className="mx-auto h-56 w-full rounded-xl object-contain" width={1240} height={1240} loading="lazy" data-id="element-22" data-mp="1jj9ur9lmnlz7" />
              </div>
              <p className="mt-4 font-sans text-[10px] font-semibold uppercase tracking-[0.2em] text-gold-ink" data-id="element-23" data-mp="3trxcnfvk89ka">
                Bonus {bonus.number}
              </p>
              <h3 className="mt-2 font-display text-xl leading-snug text-ink" data-id="element-24" data-mp="2kb1l26ih4te">
                {bonus.title}
              </h3>
              <p className="mt-auto pt-2 font-sans text-[0.85rem] leading-relaxed text-stone" data-id="element-25" data-mp="cjs2z7eqcwjk">
                {bonus.tagline}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}